import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getAddressesPage = createAsyncThunk('addressesPage/getAddressesPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getAddressPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
